export const CHAR_MAX = 253;
export const SHORT_MAX = CHAR_MAX * CHAR_MAX;
export const THREE_MAX = CHAR_MAX * CHAR_MAX * CHAR_MAX;
